<mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
<div class="modal-anulacao container-fluid" [hidden]="isLoading">
  <div class="row">
    <div class="col-md-12 border-bottom d-flex align-items-center" [hidden]="!preLoteDetails">
      <p class="page-title">{{preLoteDetails?.tipoAcaoDescricao}} (Qtd. {{ preLoteDetails?.totalLote }})
        <small>({{preLoteDetails?.descricaoStatus}})</small>
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 border-bottom d-flex flex-row align-items-center pb-1 pt-1" [hidden]="!preLoteDetails">
      <div class="mr-auto d-flex align-items-center">
        Código do lote: #{{preLoteDetails?.loteId}} | Gerado em
        {{preLoteDetails?.dataInclusao | date: 'dd/MM/yyyy HH:mm'}} por
        {{preLoteDetails?.usuario}} <br>
        <ng-container *ngIf="preLoteDetails?.nomeArquivo">Via upload ({{preLoteDetails?.nomeArquivo}})</ng-container>
        <ng-container *ngIf="!preLoteDetails?.nomeArquivo">Via pesquisa</ng-container>
      </div>
    </div>
  </div>
  <form [formGroup]="filter" class="filters">
    <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
    <mat-card *ngFor="let filtro of filtros" class="card-filter-principal" [hidden]="isLoading"
      [class]='"card-filter type-filter-"+filtro.sessaoId'>
      <mat-card-header class="header-padrao">
        <mat-card-title class="d-flex justify-content-center align-items-center">
          <span class="session-title"><b>{{filtro.title}}</b></span>
          <span class="session-qtd-faixa"></span>
          <span class="session-qtd">{{filtro.quantidade | number}}</span>
          <span class="session-valor">Total do Frete: {{filtro.totalFrete | currency: 'BRL'}}</span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="d-flex">
          <mat-card *ngFor="let card of filtro.cards" class="session-card">
            <mat-checkbox class="slide-top" [formControlName]="'filter_'+card.id"
              (change)="refreshFilter($event, card)">
              <mat-card-content>
                <div class="card-qtd">{{card.quantidade | number}}</div>
                <div class="card-title">{{card.title}}</div>
                <div class="card-divider"></div>
                <div class="card-valor">{{card.totalFrete| currency: 'BRL'}}</div>
              </mat-card-content>
            </mat-checkbox>
          </mat-card>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="card-filter-principal" [hidden]="isLoading">
      <mat-card-header class="header-padrao">
        <mat-card-title class="d-flex justify-content-start align-items-center">
          <span class="session-title"><b>Pesquisar</b></span>
          <div class="card-valor ml-auto">
            <i class="fas fa-eraser eraser-button mb-0 mt-0" (click)="clearFields()" matTooltip="Limpar Campos"></i>
            <i class="fas fa-search search-button cursor-pointer-icon ml-3" (click)="paging.index = 0; loadGrid()" matTooltip="Pesquisar"></i>
            <!-- <button mat-icon-button class="mb-0 mt-0" (click)="paging.index = 0; loadGrid()" [disabled]="filterForm.invalid">
            </button> -->
          </div>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div [formGroup]="filterForm" class="d-flex">
          <div class="align-items-center filtros-header">
            <div class="element-inline pt-3">
              <mat-form-field>
                <mat-select formControlName="clienteId" disableOptionCentering="true" placeholder="Cliente">
                          <mat-option><ngx-mat-select-search [formControl]="clienteMultiFilter" placeholderLabel="Buscar..."
        noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
                  <mat-option value="">Todos</mat-option>
                  <mat-option *ngFor="let cliente of filteredClientes | async" [value]="cliente?.id">
                    {{ cliente?.nome }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Número CT-e</mat-label>
                <input matInput placeholder="Número CT-e" formControlName="numeroCte" />
              </mat-form-field>
            </div>

            <div class="element-inline">
              <mat-form-field>
                <mat-label>Chave CT-e</mat-label>
                <input matInput placeholder="Chave CT-e" formControlName="chaveCte" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>NRT/Código do Volume/Ducumento</mat-label>
                <input matInput placeholder="NRT/Código do Volume/Ducumento" formControlName="codBarras" />
              </mat-form-field>

            </div>

          </div>
        </div>
      </mat-card-content>

    </mat-card>

  </form>
</div>
<div class="table-responsive container-fluid no-padding" [hidden]="isLoading || !grid || grid.data.length == 0">
  <table mat-table [hidden]="isLoading" [dataSource]="grid">

    <ng-container matColumnDef="action" [sticky]="true">
      <th mat-header-cell *matHeaderCellDef>Ações</th>
      <td mat-cell *matCellDef="let grid">
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu" [disabled]="grid.declaracaoId === null">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button  mat-menu-item color="primary"
            (click)="downloadDeclaracao(grid)" *ngIf="grid.declaracaoId !== null">
            <mat-icon>file_download</mat-icon>
            <span>Download Declaração</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <ng-container matColumnDef="filial">
      <th mat-header-cell *matHeaderCellDef>CNPJ Emissor</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.filialEmissaoDescricao }}
      </td>
    </ng-container>

    <ng-container matColumnDef="nrCTE">
      <th mat-header-cell *matHeaderCellDef>Nr. CTE</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.numCTE }}
      </td>
    </ng-container>
    <ng-container matColumnDef="chaveCTE" [sticky]="true">
      <th mat-header-cell *matHeaderCellDef>Chave CTE</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.chaveCTE }}
      </td>
    </ng-container>
    <ng-container matColumnDef="dtEmissao">
      <th mat-header-cell *matHeaderCellDef>Dt. Autorização</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.dtEmissao | date: 'dd/MM/yyyy' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="qtdeNRT">
      <th mat-header-cell *matHeaderCellDef>Qtde. NRT</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.qtdeNRT }}
      </td>
    </ng-container>
    <ng-container matColumnDef="qtdeNF">
      <th mat-header-cell *matHeaderCellDef>Qtde. NF</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.qtdeNF }}
      </td>
    </ng-container>
    <ng-container matColumnDef="cliente">
      <th mat-header-cell *matHeaderCellDef>Cliente</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.clienteNome }}
      </td>
    </ng-container>
    <ng-container matColumnDef="tomador">
      <th mat-header-cell *matHeaderCellDef>Tomador</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.tomador }}
      </td>
    </ng-container>
    <ng-container matColumnDef="pid">
      <th mat-header-cell *matHeaderCellDef>PID</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.pid }}
      </td>
    </ng-container>
    <ng-container matColumnDef="cepDestino">
      <th mat-header-cell *matHeaderCellDef>CEP Destino</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.cepDestino }}
      </td>
    </ng-container>

    <ng-container matColumnDef="peso">
      <th mat-header-cell *matHeaderCellDef>Peso</th>
      <td mat-cell *matCellDef="let grid" (click)="visualizarPeso(grid)">
        <span class="showLink">{{ grid.peso }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="tipoCte">
      <th mat-header-cell *matHeaderCellDef>Tipo CTE</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.tipoCteDescricao }}
      </td>
    </ng-container>

    <ng-container matColumnDef="tipoProcessamento">
      <th mat-header-cell *matHeaderCellDef>Tipo Processamento</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.tipoProcessamentoDescricao }}
      </td>
    </ng-container>

    <ng-container matColumnDef="statusCancelamento">
      <th mat-header-cell *matHeaderCellDef>Status - Cancelamento</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.tipoStatusCancelamentoDescricao ? grid.tipoStatusCancelamentoDescricao : '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="valorFrete">
      <th mat-header-cell *matHeaderCellDef>Valor Frete</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.loteValorFrete | currency: 'BRL' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="adValorem">
      <th mat-header-cell *matHeaderCellDef>AdVal.</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.loteAdValorem | currency: 'BRL' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="gris">
      <th mat-header-cell *matHeaderCellDef>Gris</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.loteGris | currency: 'BRL' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="imposto">
      <th mat-header-cell *matHeaderCellDef>Imposto</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.loteImposto | currency: 'BRL' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="totalFrete">
      <th mat-header-cell *matHeaderCellDef>Total Frete</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.loteTotalFrete | currency: 'BRL' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="statusCte">
      <th mat-header-cell *matHeaderCellDef>Status CT-e</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.statusCte }}
      </td>
    </ng-container>

    <ng-container matColumnDef="statusLote">
      <th mat-header-cell *matHeaderCellDef>Status Lote</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.statusLote }}
      </td>
    </ng-container>

    <!-- INICIO CTE ACAO -->
    <ng-container matColumnDef="numeroCTEAcao">
      <th mat-header-cell *matHeaderCellDef>Numero CT-e</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.numeroCTEAcao }}
      </td>
    </ng-container>

    <ng-container matColumnDef="chaveCteAcao">
      <th mat-header-cell *matHeaderCellDef>Chave CT-e</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.chaveCteAcao }}
      </td>
    </ng-container>

    <ng-container matColumnDef="statusCteAcao">
      <th mat-header-cell *matHeaderCellDef>Status CT-e</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.statusCteAcao }}
      </td>
    </ng-container>

    <!-- INICIO RECALCULADOS -->
    <ng-container matColumnDef="reemissao">
      <th mat-header-cell *matHeaderCellDef>Reemissão</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.reemissao }}
      </td>
    </ng-container>

    <ng-container matColumnDef="numeroCTERemissao">
      <th mat-header-cell *matHeaderCellDef>Numero CT-e</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.numeroCTERemissao }}
      </td>
    </ng-container>

    <ng-container matColumnDef="chaveCteRemissao">
      <th mat-header-cell *matHeaderCellDef>Chave CT-e</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.chaveCteRemissao }}
      </td>
    </ng-container>

    <ng-container matColumnDef="statusCteRemissao">
      <th mat-header-cell *matHeaderCellDef>Status CT-e</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.statusCteRemissao }}
      </td>
    </ng-container>

    <ng-container matColumnDef="statusBloqueio" [stickyEnd]="true">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.statusCte}}
      </td>
    </ng-container>

    <!-- Header Dados dos CT-es Originais -->
    <ng-container matColumnDef="header-row-first-group">
      <th mat-header-cell *matHeaderCellDef class="text-center" [attr.colspan]="22"
        style="background-color: gainsboro; z-index: 999">
        Dados dos CT-es Originais
      </th>
    </ng-container>
    <!-- Header CT-es Ações -->
    <ng-container matColumnDef="header-row-second-group">
      <th mat-header-cell *matHeaderCellDef class="text-center" [attr.colspan]="3"
        style="background-color: #d1d1d1; z-index: 999">
         CT-es {{ preLoteDetails?.tipoAcaoDescricao }}
      </th>
    </ng-container>

    <!-- Header Reemitidos-->
    <ng-container matColumnDef="header-row-third-group">
      <th mat-header-cell *matHeaderCellDef class="text-center" [attr.colspan]="5"
        style="background-color: #c9c9c9; z-index: 999">
        CT-es Reemitidos
      </th>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="[
                      'header-row-first-group',
                      'header-row-second-group',
                      'header-row-third-group'
                    ]"></tr>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let grid; columns: displayedColumns"
      [ngClass]="{'aguardando-processamento': grid.statusLoteId == 1,
                  'processamento-em-andamento': grid.statusLoteId == 2,
                  'procecessado': grid.statusLoteId == 0
                }">
    </tr>
  </table>
</div>

<app-paginacao *ngIf="grid && grid.data.length > 0" [pageIndex]="paging?.index" [pageSize]="paging?.size"
  [length]="paging?.length" (page)="onPageChange($event)" [pageSizeOptions]="[5, 10, 15]" [hidden]="isLoading">
</app-paginacao>

<div class="align-footer" *ngIf="grid && grid.data.length > 0" [hidden]="isLoading">
  <button mat-stroked-button type="button" [disabled]="isLoadingDownload" (click)="downloadExcel()">
    <span *ngIf="isLoadingDownload" class="d-flex align-items-center">
      <mat-spinner diameter="20" color="dark"></mat-spinner>
      &nbsp; Baixando
    </span>
    <span *ngIf="!isLoadingDownload">
      <i class="fas fa-file-excel"></i> Download Excel
    </span>
  </button>
</div>

<div *ngIf="!isLoading && grid && grid.data.length == 0" class="d-flex justify-content-center align-items-center"
  style="height: 100px;">
  Nenhum registro encontrado!
</div>
